var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 6.4 4.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    transform: "scale(8.844)",
    fill: "#fff",
    d: "M0-.5l.162.5h-.324z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-144)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72)",
    width: 18,
    height: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(144)",
    width: 18,
    height: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1-7.2h16v12H1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .4 -.4 2.88)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fecb00",
    d: "M0-7.2h18v6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea2839",
    d: "M0-1.2h18v6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34b233",
    d: "M0-3.2h18v4H0z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -7.2)",
    height: 12,
    width: 18,
    y: 6.422,
    x: 9,
    xlinkHref: "#c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/mm.ed9abfa812ad34783828c98bd618377d.svg";
export { ForwardRef as ReactComponent };